export default "__VITE_ASSET__DS1_qVfq__"